module.exports = __webpack_public_path__ + "img/symbol_2.245d6530.png";